import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { IgLoading, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { getProgresses } from "../../../store/slices/global";

export const SavingProductsPleaseWait = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const progresses = useSelector(getProgresses());

  const message = useMemo(() => {
    if (id && id in progresses) {
      const progress = progresses[id];
      if ("productProgress" in progress) {
        const percent = progress.productProgress.progress * 100;
        if (percent > 0 && percent < 100) {
          return `Saving products (${percent.toFixed(0)}%), please wait...`;
        }
      }
    }

    return "Saving products, please wait...";
  }, [progresses, id]);

  return (
    <Grid
      container
      item
      alignItems={"center"}
      justifyContent={"center"}
      direction={"column"}
      rowSpacing={2}
    >
      <Grid item>
        <IgLoading />
      </Grid>
      <Grid item>
        <IgTypography>{message}</IgTypography>
      </Grid>
    </Grid>
  );
};
